import React, { useState } from 'react';
import { 
  Row, 
  Col, 
  Card, 
  Typography, 
  Tag,
  Button,
  Space
} from 'antd';
import { theme } from '../../styles/theme';
import { Header } from '../../components/common/layout';
import { BookingModal } from '../../components/common/ui';

const { Title, Text } = Typography;

const ServicesPage = () => {
  const [bookingModalVisible, setBookingModalVisible] = useState(false);

  const services = {
    'Lawn & Yard Care': [
      { name: 'Lawn Mowing', description: 'Regular lawn maintenance and trimming' },
      { name: 'Leaf Blowing', description: 'Seasonal leaf removal and cleanup' },
      { name: 'Bush Trimming', description: 'Professional bush and shrub trimming' },
      { name: 'Weed Pulling', description: 'Complete weed removal and prevention' },
      { name: 'Garden Bed Maintenance', description: 'Garden bed cleanup and maintenance' },
      { name: 'Mulch Refresh', description: 'Fresh mulch installation and cleanup' }
    ],
    'Exterior Cleaning': [
      { name: 'Gutter Cleaning', description: 'Professional gutter cleaning and maintenance' },
      { name: 'Window Cleaning', description: 'Interior and exterior window cleaning' },
      { name: 'Power Washing', description: 'Complete exterior power washing service' },
      { name: 'Pressure Washing', description: 'Heavy-duty pressure washing for driveways and patios' },
      { name: 'Roof Cleaning', description: 'Professional roof cleaning and maintenance' },
      { name: 'Deck Cleaning', description: 'Deep clean and protect your deck' },
      { name: 'Patio Cleaning', description: 'Restore your patio to like-new condition' },
      { name: 'Driveway Cleaning', description: 'Pressure wash and seal driveway' },
      { name: 'Fence Cleaning', description: 'Clean and protect your fence' }
    ],
    'Trash & Sanitation': [
      { name: 'Trash Can Cleaning', description: 'Deep cleaning and sanitizing of trash cans' },
      { name: 'Spider Web Removal', description: 'Complete spider web removal service' }
    ],
    'Specialty Services': [
      { name: 'Solar Panel Cleaning', description: 'Safe and effective solar panel cleaning' },
      { name: 'Gutter Guard Installation', description: 'Professional gutter guard installation' },
      { name: 'Garage Clean Out', description: 'Complete garage organization and cleanup' },
      { name: 'Landscape Lighting', description: 'Professional landscape lighting installation' },
      { name: 'Exterior Touch-Up Painting', description: 'Professional exterior painting touch-ups' }
    ],
    'Educational Services': [
      { name: 'DIY Workshop', description: 'Learn home maintenance skills and techniques' },
      { name: 'DIY Coaching', description: 'Virtual home maintenance guidance and support' },
      { name: 'Virtual Estimates', description: 'Free estimates for all services' }
    ]
  };

  return (
    <>
      <Header />
      <div style={{ padding: '40px 0', marginTop: '80px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        {/* Page Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <Title level={1} style={{ 
            color: theme.colors.primary, 
            fontFamily: theme.fonts.primary,
            marginBottom: '1rem',
            fontSize: '2.5rem',
            fontWeight: '700'
          }}>
            Our Services
          </Title>
          <Text style={{ 
            fontSize: '1.1rem', 
            color: theme.colors.gray,
            fontFamily: theme.fonts.primary,
            fontWeight: '500'
          }}>
            Professional home maintenance services to keep your property in perfect condition
          </Text>
        </div>

        {/* Services by Category */}
        {Object.entries(services).map(([category, categoryServices]) => (
          <div key={category} style={{ marginBottom: '3rem' }}>
            <Title level={2} style={{ 
              color: theme.colors.primary, 
              fontFamily: theme.fonts.primary,
              marginBottom: '1.5rem',
              borderBottom: `2px solid ${theme.colors.primary}`,
              paddingBottom: '0.5rem'
            }}>
              {category}
            </Title>
            
            <Row gutter={[16, 16]}>
              {categoryServices.map((service, index) => (
                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                  <Card 
                    style={{ 
                      height: '100%',
                      border: `1px solid ${theme.colors.borderGray}`,
                      borderRadius: theme.borderRadius.lg,
                      boxShadow: theme.shadows.sm,
                      transition: 'all 0.3s ease',
                      fontFamily: theme.fonts.primary
                    }}
                    styles={{ body: { padding: '1.5rem' } }}
                    hoverable
                  >
                    <Title level={4} style={{ 
                      marginBottom: '0.5rem',
                      color: theme.colors.primary,
                      fontFamily: theme.fonts.primary,
                      fontSize: '1.1rem'
                    }}>
                      {service.name}
                    </Title>
                    <Text style={{ 
                      color: theme.colors.gray,
                      fontFamily: theme.fonts.primary,
                      fontSize: '0.95rem'
                    }}>
                      {service.description}
                    </Text>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))}

        {/* Call to Action Section */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '4rem',
          padding: '3rem 2rem',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          borderRadius: '20px',
          border: '1px solid rgba(0,0,0,0.05)'
        }}>
          <Title level={2} style={{ 
            color: theme.colors.primary, 
            fontFamily: theme.fonts.primary,
            marginBottom: '1rem',
            fontSize: '2rem',
            fontWeight: '700'
          }}>
            Ready to Get Started?
          </Title>
          <Text style={{ 
            fontSize: '1.1rem', 
            color: theme.colors.gray,
            fontFamily: theme.fonts.primary,
            fontWeight: '500',
            marginBottom: '2rem',
            display: 'block'
          }}>
            Choose from our professional home maintenance services and get your free quote today
          </Text>
          
          <Button 
            type="primary" 
            size="large"
            style={{ 
              background: 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)',
              border: 'none',
              borderRadius: '16px',
              height: '50px',
              padding: '0 30px',
              fontSize: '16px',
              fontWeight: '700',
              boxShadow: '0 8px 25px rgba(39, 174, 96, 0.4)',
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontFamily: theme.fonts.primary
            }}
            onClick={() => setBookingModalVisible(true)}
          >
            Get Free Quote
          </Button>
        </div>
      </div>
    </div>
    <BookingModal 
      visible={bookingModalVisible} 
      onClose={() => setBookingModalVisible(false)} 
      source="services_page_quote" 
    />
    </>
  );
};

export default ServicesPage;
